import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import Input from "../Input";
import { Container } from "./styles";
import * as yup from "yup";
import { useUser } from "../../providers/users";
import { useTranslation } from "react-i18next";
import { Button, TextField } from "@mui/material";
import { IoMdClose } from "react-icons/io";
import { useRegistrantEvent } from "../../providers/registrantEvents";
import { IRegistrant } from "../../providers/registrantEvents/registrantEvents.interface";

interface IPropps {
  setModalUpdateRegistrant: React.Dispatch<React.SetStateAction<boolean>>;

  item: IRegistrant;
}

const ModalUpdateRegistrant = ({
  setModalUpdateRegistrant,

  item,
}: IPropps) => {
  const { t } = useTranslation();
  const { apiLoading } = useUser();
  const { updateRegistrant } = useRegistrantEvent();
  const formSchema = yup
    .object()
    .shape({
      name: yup.string().max(128, t("field_max")),
      email: yup.string().max(128, t("field_max")),
      phone: yup.string().max(128, t("field_max")),
    })
    .required();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema),
  });
  type FormValues = yup.InferType<typeof formSchema>;
  const onSubmit = (data: FormValues) => {
    updateRegistrant(item.id, data);
    setModalUpdateRegistrant(false);
  };

  return (
    <Container>
      <div className="modalContainer">
        <form>
          <div className="modalHeader">
            <h3>Update Registrant</h3>
            <div className="modalButtonsHeader">
              <Button
                variant="outlined"
                size="large"
                disabled={apiLoading}
                sx={{ mr: 1, borderRadius: "25px" }}
                onClick={() => setModalUpdateRegistrant(false)}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                size="large"
                disabled={apiLoading}
                sx={{ mr: 1, borderRadius: "25px" }}
                onClick={handleSubmit(onSubmit)}
              >
                Save
              </Button>
            </div>
          </div>
          <TextField
            error={errors.name === undefined ? false : true}
            helperText={errors.name?.message?.toString()}
            id="standard-name"
            defaultValue={item.name}
            label="Name"
            variant="filled"
            InputProps={{
              disableUnderline: true,
            }}
            sx={{
              boxShadow: "rgba(3,3,3,0.1) 2px 2px 4px ",
              textAlign: "center",
              backgroundColor: "#FFF",
              "& fieldset": { border: "none" },
            }}
            {...register("name")}
          />
          <TextField
            error={errors.email === undefined ? false : true}
            helperText={errors.email?.message?.toString()}
            id="standard-email"
            defaultValue={item.email}
            label="Email"
            type="email"
            variant="filled"
            InputProps={{
              disableUnderline: true,
            }}
            sx={{
              boxShadow: "rgba(3,3,3,0.1) 2px 2px 4px ",
              textAlign: "center",
              backgroundColor: "#FFF",
              "& fieldset": { border: "none" },
            }}
            {...register("email")}
          />
          <TextField
            error={errors.phone === undefined ? false : true}
            helperText={errors.phone?.message?.toString()}
            id="standard-phone"
            defaultValue={item.phone}
            label="Phone"
            type="phone"
            variant="filled"
            InputProps={{
              disableUnderline: true,
            }}
            sx={{
              boxShadow: "rgba(3,3,3,0.1) 2px 2px 4px ",
              textAlign: "center",
              backgroundColor: "#FFF",
              "& fieldset": { border: "none" },
            }}
            {...register("phone")}
          />
        </form>
      </div>
    </Container>
  );
};

export default ModalUpdateRegistrant;
